<template>
    <div v-if="ready">
        <form
            class="form-horizontal"
            enctype="multipart/form-data"
            @submit.prevent="store"
            @keydown="form.errors.clear($event.target.name)"
            novalidate
            autocomplete="off"
        >
            <div class="form-group row" v-if="project">
                <label class="form-control-label col-form-label col-md-3 col-xl-2 col-sm-12">{{ uLang('app.trajectory_project') }}:</label>
                <div class="col-md-9 col-xl-10 col-sm-12">
                    <input type="text" class="form-control" disabled :value="project.name">
                </div>
            </div>

            <form-input :form="form" required name="name"/>

            <form-textarea name="description" :form="form"/>

            <backend-select
                v-model="form.trajectory_type_id"
                :route="route('settings.values.index', { setting: 12 })"
                :error="form.errors.get('trajectory_type_id')"
                :value="field('trajectory_type_id')"
                object-name-key="value"
                return="id"
                name="trajectory_type"
                label="trajectory_type"
            />

            <form-input :form="form" min="0" type="number"  name="maximum_hours"/>

            <form-input :form="form" min="0" type="number"  name="lead_time_in_days"/>

            <form-input
                :form="form"
                min="0"
                step="1"
                max="100"
                type="number"
                name="minimum_success_rate"
            />

            <backend-select :error="form.errors.get('email_template_id')" return="id" :value="field('email_template_id')"
                            v-model="form.email_template_id" name="email_template" label="email_template"
                            :route="route('action-documents.index', { category: 'e-mail' })"/>

            <div class="form-group row" v-bind:class="{ 'has-danger' : form.errors.has('fact_sheet') }">
                <label class="form-control-label col-md-3 col-xl-2 col-sm-12 col-form-label" for="fact_sheet">{{ uLang('app.fact_sheet') }}:</label>
                <div class="col-md-9 col-xl-10 col-sm-12">
                    <form-file id="fact_sheet" v-model="form.fact_sheet" :placeholder="uLang('app.no_file_chosen')" :choose-label="uLang('app.choose_file')"/>
                    <span class="help-block form-control-feedback" v-if="form.errors.has('fact_sheet')" v-text="form.errors.get('fact_sheet')"></span>
                </div>
            </div>

            <!-- ID-266 UNDO --> <dual-select
                inputLabel="app.trajectory_managers"
                :error="form.errors.get('trajectory_managers')"
                name="trajectory_managers"
                :route="route('relations.index', { role: 'trajectory_manager', available_only: 1 })"
                v-model="form.trajectory_managers"
                :search="true"
                required
            /> <!-- ID-266 UNDO --> 

            <!-- // ID-266 Not needed anymore as only other roles will get the logs (in the checkboxes above) -->
             <!-- ID-266 UNDO --> 
            <dual-select
                inputLabel="app.trajectory_inspectors"
                :error="form.errors.get('trajectory_inspectors')"
                name="trajectory_inspectors"
                :route="route('relations.index', { role: 'trajectory_inspector' })"
                v-model="form.trajectory_inspectors"
                required
            />  <!-- ID-266 UNDO --> 
            <!--             <backend-select :form="form" :error="form.errors.get('trajectory_inspectors')" name="trajectory_inspectors"
                            label="trajectory_inspectors" :route="route('admin.roles.relations', { role: 2 })" return="id"
                            :value="field('trajectory_inspectors')" v-model="form.trajectory_inspectors" object-name-key="full_name" required multiple/>
            -->


            <!-- // ID-266 Not needed anymore as only other roles will get the logs (in the checkboxes above) -->
             <!-- ID-266 UNDO --> 
            <dual-select
                inputLabel="app.trajectory_administrators"
                :error="form.errors.get('trajectory_administrators')"
                name="trajectory_administrators"
                :route="route('relations.index', { role: 'trajectory_administrator' })"
                v-model="form.trajectory_administrators"
                required
            /> <!-- ID-266 UNDO --> 
            <!--             <backend-select :form="form" :error="form.errors.get('trajectory_administrators')" name="trajectory_administrators"
                            label="trajectory_administrators" :route="route('admin.roles.relations', { role: 3 })" return="id"
                            :value="field('trajectory_administrators')" v-model="form.trajectory_administrators" object-name-key="full_name" required multiple/>
            -->

            <!-- ID-266 UNDO -->  <dual-select
                inputLabel="app.casemanagers"
                :error="form.errors.get('casemanagers')"
                name="casemanagers"
                :route="route('relations.index', { role: 'casemanager' })"
                v-model="form.casemanagers"
            /> <!-- ID-266 UNDO --> 

            <backend-select
                :form="form"
                :error="form.errors.get('reporting_person_id')"
                name="reporting_person"
                return="id"
                label="reporting_person"
                :route="route('organisations.relations.index', {organisation: project.client_id, role: ['contact']})"
                :value="field('reporting_person_id')"
                v-model="form.reporting_person_id"
                object-name-key="display_name"
            />

            <backend-select :form="form" :error="form.errors.get('blik_op_werk_id')" name="blik_op_werk_id" return="id"
                            label="service_according_to_blik_op_werk" :route="route('admin.settings.values.to_blik_op_werk')"
                            :value="field('blik_op_werk_id')" v-model="form.blik_op_werk_id" trackBy="value" object-name-key="value"/>

            <active-select
                :error="form.errors.get('active')"
                return="id"
                :value="field('active')"
                v-model="form.active"
                required
            />

            <div class="form-group row">
                <label class="form-control-label col-md-3 col-xl-2 col-sm-12 col-form-label" for="in_result_dashboard">{{ uLang('app.in_result_dashboard') }}</label>
                <div class="col-md-9 col-xl-10 col-sm-12">
                    <label class="custom-control custom-checkbox mt-2">
                        <input type="checkbox" class="custom-control-input" id="in_result_dashboard" value="1" v-model="form.in_result_dashboard">
                        <span class="custom-control-indicator"></span>
                    </label>
                </div>
            </div>

            <yes-no-select
                v-if="false"
                v-model="form.in_bow_export"
                :error="form.errors.get('in_bow_export')"
                name="in_bow_export"
                :yes-label="uLang('app.in_bow_export')"
                :no-label="uLang('app.not_in_bow_export')"
            />

            <div class="form-group row">
                <label class="form-control-label col-md-3 col-xl-2 col-sm-12 col-form-label" for="variable_trajectory_prices">{{ uLang('app.variable_trajectory_prices') }}</label>
                <div class="col-md-9 col-xl-10 col-sm-12">
                    <label class="custom-control custom-checkbox mt-2">
                        <input type="checkbox" class="custom-control-input" id="variable_trajectory_prices" value="1" v-model="form.variable_trajectory_prices">
                        <span class="custom-control-indicator"></span>
                    </label>
                </div>
            </div>

            <div class="form-group fr-absolute">
                <input :disabled="form.busy" type="submit" class="btn btn-brand"
                       :value="uLang('app.save')"/>
            </div>
        </form>
    </div>
</template>

<script>
    import Form from '~/Form/Form'
    import FormMixin from '~/mixins/form'
    import DualSelect from '~/Form/elements/dual-select'
    import SuccessfullyStoredAlert from "~/Swals/SuccessfullyStoredAlert";
    import SuccessfullyUpdatedAlert from "~/Swals/SuccessfullyUpdatedAlert";
    import YesNoSelect from "../../../../elements/selects/yes-no"

    export default {
        name: 'trajectory-form',

        components: {
            YesNoSelect,
            DualSelect
        },

        mixins: [FormMixin],

        props: {
            project: {
                type: Object,
                required: false,
                default: null,
            },
            id: {
                required: false,
            },
        },

        watch: {
            "form.fact_sheet"(newVal) {
                // Hacky solution to clear the form to null when it gets automatically filled by the form mixin
                if(newVal && newVal.id) {
                    this.form.fact_sheet = null
                }
            }
        },

        created() {
            this.$on('afterStore', this.afterStore);
            this.$on('afterUpdate', this.afterUpdate);
        },

        data() {
            return {
                entity: 'trajectory',
                form: new Form({
                    name: '',
                    description: '',
                    maximum_hours: null,
                    lead_time_in_days: null,
                    minimum_success_rate: null,
                    email_template_id: null,
                    fact_sheet: null,
                    trajectory_managers: null,
                    trajectory_inspectors: null, // ID-266 
                    trajectory_administrators: null, // ID-266 
                    casemanagers: null,
                    reporting_person_id: null,
                    trajectory_type_id: null,
                    blik_op_werk_id: null,
                    variable_trajectory_prices: false,
                    active: false,
                    in_result_dashboard: true,
                    in_bow_export: true
                }),
                swal: false,
            }
        },

        methods: {
            async retrieveReportingPersons(organisationId) {
                this.fields_loading.reporting_persons = true;
                const { data } = await window.axios.get(route('organisations.relations.index', {organisation: organisationId, role: ['contact']}));
                this.reporting_persons = data;
                this.fields_loading.reporting_persons = false;
            },

            afterStore(data) {
                new SuccessfullyStoredAlert({entity: this.lang('app.trajectory')}).show()
                    .then((buttonPressed) => {
                        if (buttonPressed === 'create_another') {
                            // Form mixin clears fields already
                        } else if (buttonPressed === 'show') {
                            this.$router.push({name: 'admin.trajectory_projects.trajectories.view', params: {
                                projectId: this.project.id,
                                id: data.id,
                            }});
                        }
                    });
            },

            afterUpdate(data) {
                new SuccessfullyUpdatedAlert({entity: this.lang('app.trajectory')}).show()
                    .then(() => {
                        this.$router.push({name: 'admin.trajectory_projects.trajectories.view', params: {
                            projectId: this.project.id,
                            id: this.id,
                        }});
                    });
            },
        }
    }
</script>

<style lang="css" scoped>

</style>
